import React from 'react'

const Shimme = () => {
  return (
    <div className='shimmer'></div>
  )
}

export default Shimme